// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__Q2xWE","paginationContainer":"Pagination_paginationContainer__WRUZo"};